<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img :src="img" alt="Circle Image" class="img-raised rounded-circle img-fluid">
                </div>
                <div class="name">
                  <h3 class="title">Vale Vista SNTDR</h3>
                  <h6>Política de Privacidad</h6>
                  <h7>Última modificación: 22 de julio de 2019</h7>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              Vale vista SNTDR es la app para ver si tienes Vales vista disponibles al rut consultado!
              <br>Podrás simplificar la tarea y disminuir mucho el tiempo en obtener esta información.
            </p>
          </div>
          <div>
              Debes saber cómo funciona esta aplicación, para eso te explicamos cómo trabaja.
              <br><br>
              <p>1.- Ingresas tu RUT</p>
              <p>2.- Das a consultar y en ese momento tu rut se ingresa en la web de consulta del banco sntdr, y trae una respuesta (cantidad de vale vista a ese rut)</p>
              <p>3.- Te mostramos el resultado. Asi de facil.
              </p>
          </div>
          <div>
              Cuando utilizas esta aplicacion, compartes ciertos datos con nosotros. Este documento te explica que informacion compartes. Leelo con cuidado.
              <br>
              <h3><strong>Información que recabamos</strong></h3>
              <h4><strong>Información que tu decides compartir con nosotros</strong></h4>
              Ninguna información
              <h4><strong>Información que tu nosotros recolectamos</strong></h4>
              Ninguna información
              <br><br>
              <strong>Finalmente, recordamos que tus datos de ingresos no son guardados en ninguna parte ni en ningun lugar.</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {};
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg23.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/portfolio/logo_valevistasntdr.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
